import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10 7.75a.75.75 0 0 0-.75.75v7c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-7a.75.75 0 0 0-.75-.75z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M21.75 15.5a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 .75.75zm-1.5-.75v-5.5h-2.5v5.5zM7.75 15.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-7A.75.75 0 0 1 3 7.75h4a.75.75 0 0 1 .75.75zm-1.5-.75v-5.5h-2.5v5.5z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }